import React from "react"
import PropTypes from "prop-types"
import { Stack } from "@mantine/core"

import { LegislationSummary, StatusBar } from "quorumdesign"
import { SummarySection } from "app/static/frontend/profiles-new/components/BillSummary/SummarySection"

const BillSummary = ({
    aiSummaryText,
    aiSummaryDate,
    aiSummarySingleSentence,
    statusBarLabels,
    statusBarNumberCompleted,
    sessionEndDate,
    sessionStartDate,
    statusDate,
    statusText,
    summaryLabel,
    summaryText,
}) => (
    <Stack spacing="md">
        {(summaryLabel || summaryText || aiSummaryText) && (
            <SummarySection
                aiSummary={aiSummaryText}
                aiSummaryDate={aiSummaryDate}
                aiSummarySingleSentence={aiSummarySingleSentence}
                officialSummary={summaryText}
            />
        )}
        {(statusText || statusDate || sessionStartDate || sessionEndDate) && (
            <LegislationSummary
                statusText={statusText}
                statusDate={statusDate}
                sessionStartDate={sessionStartDate}
                sessionEndDate={sessionEndDate}
            />
        )}
        {statusBarLabels && <StatusBar labels={statusBarLabels} numCompleted={statusBarNumberCompleted} />}
    </Stack>
)

BillSummary.propTypes = {
    aiSummaryText: PropTypes.string,
    aiSummarySingleSentence: PropTypes.string,
    // array of labels, one for each notch on the status bar
    statusBarLabels: PropTypes.array,
    // integer number of steps to fill in from left to right
    statusBarNumberCompleted: PropTypes.number,
    // session and status dates and text to display in the summary
    sessionEndDate: PropTypes.string,
    sessionStartDate: PropTypes.string,
    statusDate: PropTypes.string,
    statusText: PropTypes.string,
    summaryLabel: PropTypes.string,
    summaryText: PropTypes.string,
}

export default BillSummary
